import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;
export default {
  state: {
    companies: [],
    brokerCompanies: [],
    selectedCompany: {},
    companiesLoading: false,
  },
  getters: {
    companies: (state) => state.companies,
    brokerCompanies: (state) => state.brokerCompanies,
    selectedCompany: (state) => state.selectedCompany,
    companiesLoading: (state) => state.companiesLoading,
  },
  mutations: {
    setCompanies: (state, data) => {
      state.companies = data;
    },
    setBrokerCompanies: (state, data) => {
      state.brokerCompanies = data;
    },

    setSelectedCompany: (state, data) => {
      state.selectedCompany = data;
    },
    setCompaniesLoading: (state, isLoading) => {
      state.companiesLoading = isLoading;
    }
  },
  actions: {
    getCompanies: async ({ commit }, teamId) => {
      try {
        const response = await api({ requiresAuth: true }).get(`/v1/companies?team_id=${teamId}`);
        const {
          data: { data },
        } = response;
        commit("setCompanies", data);
      } catch (err) {
        console.error(err);
      }
    },

    getBrokerCompanies: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/broker-companies"
        );
        const { data } = response.data;
        commit("setBrokerCompanies", data);
      } catch (err) {
        console.error(err);
      }
    },

    getCompany: (_, companyId) =>
      new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .get(`/v1/companies/${companyId}`)
          .then(
            (response) => {
              const { data } = response.data;
              resolve(data);
            },
            (err) => {
              reject(err);
            }
          );
      }),

    addCompanyLogo: async (_, { companyId, file }) => {
      try {
        const formData = new FormData();
        formData.append("logo", file);
        await api({ requiresAuth: true }).post(
          `/v1/companies/${companyId}/files`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } catch (err) {
        console.error(err);
      }
    },

    addCompany: async (
      { dispatch, commit },
      {
        teamIds,
        companyName,
        companyFullName,
        companyType,
        viewInApp,
        status,
        mandate_email,
        mandate_distribution_list,
        comment,
        address,
        zip,
        city,
        country,
        phone,
        fax,
        email,
        homepage,
        services,
        file,
      }
    ) => {
      try {
        const response = await api({ requiresAuth: true }).post(
          "/v1/companies",
          {
            teams: teamIds,
            name: companyName,
            full_name: companyFullName,
            address,
            zip,
            city,
            country_code: country,
            phone,
            fax,
            email,
            web: homepage,
            status,
            comment,
            mandate_email,
            mandate_distribution_list,
            branch_category_services: services,
            show_on_app: viewInApp,
            company_type: companyType,

          }
        );

        const { data } = response.data;

        if (file) {
          await dispatch("addCompanyLogo", { companyId: data.id, file });
        }

        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.companyContactAddedSuccessfully"),
        });
      } catch (err) {
        console.error(err);
      }
    },

    updateCompany: async (
      _,
      {
        companyId,
        name,
        companyFullName,
        companyType,
        viewInApp,
        status,
        comment,
        mandate_email,
        mandate_distribution_list,
        address,
        zip,
        city,
        country,
        phone,
        fax,
        email,
        homepage,
        branchId,
        services,

      },) =>
      await api({ requiresAuth: true }).patch(`/v1/companies/${companyId}`, {
        name,
        full_name: companyFullName,
        company_type: companyType,
        is_app: viewInApp,
        status,
        comment: comment,
        mandate_email,
        mandate_distribution_list,
        address,
        zip,
        city,
        country,
        phone,
        fax,
        email,
        homepage,
        branch_id: branchId,
        branch_category_services: services,
      }
      ),

    deleteCompany: async ({ commit }, companyId) => {
      commit("setCompaniesLoading", true);
      try {
        await api({ requiresAuth: true }).delete(`/v1/companies/${companyId}`);
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.companyDeletedSuccessfully"),
        });
      } catch (err) {
        const backendError = err.response && err.response.data && err.response.data.error;
        const displayMessage = backendError || t("messages.failedToDeleteCompany");
        commit("setToast", {
          display: true,
          type: "error",
          message: displayMessage, 
        }); 
      } finally {
        commit("setCompaniesLoading", false);
      }
    },
  },
}